import * as angular from 'angular';
import 'angular-messages';
import 'angular-translate';
import 'angular-dynamic-locale';
import 'messageformat';
import 'angular-translate-interpolation-messageformat';
import 'reflect-metadata';
import 'angular-native-dragdrop';
import 'ng-sortable';


import { bundle } from 'ng-metadata/core';
import { AccordionModule } from './components/accordion/accordion.module';
import { AnnouncementModule } from './components/announcement/announcement.module';
import { AppContainerModule } from './components/app-container/app-container.module';
import { ButtonModule } from './components/button/button.module';
import { CardGridListModule } from './components/card-grid-list/card-grid-list.module';
import { ChipsModule } from './components/chips/chips.module';
import { CollectionModule } from './components/collection/collection.module';
import { ContentDocumentsModule } from './components/content-documents/content-documents.module'
import { ContentStreamModule } from './components/content-stream/content-stream.module';
import { DataFormattingModule } from './components/data-formatting/data-formatting.module';
import { DatePickerModule } from './components/date-picker/date-picker.module';
import { DateRangeModule } from './components/date-range/date-range.module';
import { DialogModule } from './components/dialog/dialog.module';
import { EmptyStateModule } from './components/empty-state/empty-state.module';
import { FabModule } from './components/fab/fab.module';
import { FormModule } from './components/form/form.module';
import { FavToggleModule } from './components/fav-toggle/fav-toggle.module';
import { HeroModule } from './components/hero/hero.module';
import { IconModule } from './components/icon/icon.module';
import { LayoutModule } from './components/layout/layout.module';
import { LoaderModule } from './components/loader/loader.module';
import { MenuModule } from './components/menu/menu.module';
import { ResizerModule } from './components/resizer/resizer.module';
import { StepperModule } from './components/stepper/stepper.module';
import { TableModule } from './components/table/table.module';
import { ToastModule } from './components/toast/toast.module';
import { ToolbarModule } from './components/toolbar/toolbar.module';
import { TooltipModule } from './components/tooltip/tooltip.module';
import { AutocompleteModule } from './components/autocomplete/autocomplete.module';
import { WafersModule } from './components/wafers/wafers.module';
import { ColorsModule } from './components/colors/colors.module';
import { FindModule } from './components/find/find.module';
import { BannerModule } from './components/banner/banner.module';
import { SnackbarModule } from './components/snackbar/snackbar.module';
import { InputModule } from './components/input/input.module';
import { SourceAvatarModule } from './components/source-avatar/source-avatar.module';

import './gaf-ng-components-polyfills';

import { EnvDetectorModule } from './components/env-detector/env-detector.module';
import { StickyHeaderModule } from './components/sticky-header/sticky-header.module';

import { MwMiniModalDialogController } from './components/dialog/mini-modal/mini-modal.dialog.controller'

import { configureMdGestureProvider } from './providers/md-gesture-provider.config';
import { configureMdIconProvider } from './providers/md-icon-provider.config';
import { configureTranslateProvider } from './providers/translate-provider.config';
import { configureResourceWhitelist } from './providers/app.resource-whitelist.config';

import { momentPickerConfig } from './components/date-picker/date-picker.config';

import { initializeMdMenuEventHandlers } from './components/menu/menu.config';

import { Provider, Directive } from './components/date-picker/angular-moment-picker/index';

import SearchModule from './components/search/search.module';

import 'ng-sortable/dist/ng-sortable.min.css';
import './gaf-ng-components.scss';
import './components/date-picker/angular-moment-picker/index.less';
import './components/date-picker/angular-moment-picker/themes/material-ui.less';
import { BadgeModule } from './components/badge/badge.module';


// tslint:disable-next-line:no-default-export
export default angular
    .module('mwAppComponents', [
        'ngMaterial',
        'pascalprecht.translate',
        'md.data.table',
        'tmh.dynamicLocale',
        'ang-drag-drop',
        'as.sortable',
        SearchModule.name,
        bundle(AccordionModule).name,
        bundle(AnnouncementModule).name,
        bundle(AppContainerModule).name,
        bundle(ButtonModule).name,
        bundle(CardGridListModule).name,
        bundle(ChipsModule).name,
        bundle(CollectionModule).name,
        bundle(ContentDocumentsModule).name,
        bundle(ContentStreamModule).name,
        bundle(DataFormattingModule).name,
        bundle(DatePickerModule).name,
        bundle(DateRangeModule).name,
        bundle(DialogModule).name,
        bundle(EmptyStateModule).name,
        bundle(FabModule).name,
        bundle(FavToggleModule).name,
        bundle(FormModule).name,
        bundle(HeroModule).name,
        bundle(IconModule).name,
        bundle(LayoutModule).name,
        bundle(LoaderModule).name,
        bundle(MenuModule).name,
        bundle(EnvDetectorModule).name,
        bundle(ResizerModule).name,
        bundle(StickyHeaderModule).name,
        bundle(StepperModule).name,
        bundle(TableModule).name,
        bundle(ToastModule).name,
        bundle(ToolbarModule).name,
        bundle(TooltipModule).name,
        bundle(AutocompleteModule).name,
        bundle(WafersModule).name,
        bundle(ColorsModule).name,
        bundle(FindModule).name,
        bundle(InputModule).name,
        bundle(BadgeModule).name,
        bundle(BannerModule).name,
        bundle(SnackbarModule).name,
        bundle(SourceAvatarModule).name
    ])
    .controller('MwMiniModalDialogController', MwMiniModalDialogController)
    .provider('momentPicker', [() => new Provider()])
    .directive('momentPicker', [
        '$timeout', '$sce', '$log', '$window', 'momentPicker', '$compile', '$templateCache',
        ($timeout: ng.ITimeoutService, $sce: ng.ISCEService, $log: ng.ILogService, $window: ng.IWindowService, momentPicker: Provider,
        $compile: ng.ICompileService, $templateCache: ng.ITemplateCacheService) => {
            return new Directive($timeout, $sce, $log, $window, momentPicker, $compile, $templateCache);
        }
    ])
    .config(momentPickerConfig)
    .config(function(tmhDynamicLocaleProvider) {
        tmhDynamicLocaleProvider.localeLocationPattern('https://assets.meltwater.io/cloudflare/ajax/libs/angular-i18n/1.6.9/angular-locale_{{locale}}.min.js');
    })
    .config(configureMdGestureProvider)
    .config(configureMdIconProvider)
    .config(configureTranslateProvider)
    .config(configureResourceWhitelist)
    .constant('$MD_THEME_CSS', '')
    .constant('MW_STATE_TRACKING_ENABLED', false)
    .run(initializeBodyElement)
    .run(initializeMdMenuEventHandlers);


function initializeBodyElement(mwEnvDetector, $rootScope, $mdMedia) {
    'ngInject';
    // Add 'mw' id to body, this helpful in our CSS, allowing us to use the ID selector to override deep class specifity trees
    let bodyElem = angular.element(document).find('body');
    bodyElem[0].id = 'mw';

    // Add OS, Browser and Device classes to body element
    mwEnvDetector.addEnvClassesToElement(bodyElem);

    function getScreenSize() {
        if ($mdMedia('xs')) { return 'xs'; }
        if ($mdMedia('sm')) { return 'sm'; }
        if ($mdMedia('md')) { return 'md'; }
        if ($mdMedia('lg')) { return 'lg'; }
        if ($mdMedia('xl')) { return 'xl'; }
    }

    $rootScope.$watch(getScreenSize, (screenSize) => {
        bodyElem.removeClass('xs');
        bodyElem.removeClass('sm');
        bodyElem.removeClass('md');
        bodyElem.removeClass('lg');
        bodyElem.removeClass('xl');
        if (!bodyElem.hasClass(screenSize)) {
            bodyElem.addClass(screenSize);
        }
    });
}



// WEBPACK FOOTER //
// ./src/lib/gaf-ng-components.ts